import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Clock, Building2, Bed } from "lucide-react";
interface AboutSectionProps {
  name: string;
  description: string;
  visitingHours: string;
  category?: string;
  maxOccupancy?: number;
}
export function AboutSection({
  name,
  description,
  visitingHours,
  category,
  maxOccupancy
}: AboutSectionProps) {
  // Process the description to handle line breaks (both actual newlines and literal \n\n strings)
  const paragraphs = description
    ? description
        .replace(/Co\./g, 'TEMP_CO_MARKER')
        .replace(/\\n\\n/g, '\n\n') // Convert literal \n\n to actual newlines
        .replace(/\\n/g, '\n') // Convert literal \n to actual newlines
        .split(/\n\n+/)
        .filter(p => p.trim())
        .map(p => p.replace(/TEMP_CO_MARKER/g, 'Co.'))
    : [];
  return <section aria-labelledby="about-section-title" className="bg-white rounded-lg border border-gray-100 shadow-sm">
      <Card className="border-0 shadow-none">
        <CardHeader className="pb-2">
          <CardTitle id="about-section-title" className="text-2xl text-grandpal-green-dark">About {name}</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div className="space-y-4">
              {paragraphs.map((paragraph, index) => <p key={index} className="text-gray-600">
                  {paragraph.trim()}
                </p>)}
              
              {paragraphs.length === 0 && <p className="text-gray-600">
                  Information about {name} will be available soon.
                </p>}
            </div>
            
            
          </div>
        </CardContent>
      </Card>
    </section>;
}